// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /*
   * Reference tokens are private implementation inputs. Components must never
   * consume them directly; customer themes override semantic tokens below.
   */
  --ref-color-offwhite: #f6f6f4;
  --ref-color-white: #fafafa;
  --ref-color-true-white: #ffffff;
  --ref-color-sand: #e8e4dd;
  --ref-color-wood: #352e2a;
  --ref-color-charcoal: #191919;
  --ref-color-black: #111111;
  --ref-color-gray-00: #f1f1f1;
  --ref-color-gray-01: #d9d9d9;
  --ref-color-gray-02: #c5c5c5;
  --ref-color-gray-03: #b6b6b6;
  --ref-color-gray-04: #838383;
  --ref-color-gray-05: #525252;
  --ref-color-green: #2b5a25;
  --ref-color-green-medium: #b2cdbc;
  --ref-color-green-light: #ddebe2;
  --ref-color-blue: #0c5099;
  --ref-color-blue-medium: #a6c3ea;
  --ref-color-blue-light: #ddebff;
  --ref-color-red: #8b2727;
  --ref-color-red-medium: #8e4b4a;
  --ref-color-red-light: #e1c9c9;
  --ref-color-yellow: #ffc30e;
  --ref-color-yellow-medium: #ffe8a0;
  --ref-color-yellow-light: #fff4d3;
  --ref-shadow-ink: 53, 46, 42;

  /* System typography tokens. rem values honor the host's root font size. */
  --font-display: "Neue Haas Grotesk Display", "Helvetica Neue", Arial, sans-serif;
  --font-text: "Neue Haas Grotesk Text", "Helvetica Neue", Arial, sans-serif;
  --fw-light: 300;
  --fw-regular: 400;
  --fw-medium: 500;
  --fw-bold: 700;
  --fs-display: 4rem;
  --fs-h1: 3rem;
  --fs-h2: 2.25rem;
  --fs-h3: 1.75rem;
  --fs-h4: 1.375rem;
  --fs-body-lg: 1.25rem;
  --fs-body: 1.125rem;
  --fs-body-sm: 1rem;
  --fs-caption: 0.875rem;
  --fs-micro: 0.75rem;
  /* Dense product scale used by the supplied Delivery prototype. */
  --fs-ui-micro: 0.625rem;
  --fs-ui-label: 0.65625rem;
  --fs-ui-eyebrow: 0.6875rem;
  --fs-ui-meta: 0.71875rem;
  --fs-ui-caption: 0.75rem;
  /* The layout spec's 12.5px body copy (D115): dense rows, facts, drawer prose. */
  --fs-ui-body: 0.78125rem;
  --fs-ui: 0.8125rem;
  --fs-ui-emphasis: 0.84375rem;
  --fs-ui-title: 0.9375rem;
  --fs-ui-page-title: 1.1875rem;
  --fs-ui-home-title: 1.6875rem;
  /* The layout spec's big number, one per page (34px, the low end of its 34-48px range). */
  --fs-ui-verdict: 2.125rem;
  --fs-audit-score: 2.875rem;
  --lh-display: 1;
  --lh-h1: 1.06;
  --lh-h2: 1.08;
  --lh-tight: 1.2;
  --lh-home: 1.15;
  --lh-body: 1.6;
  --lh-snug: 1.45;
  --ls-display: -0.01em;
  --ls-body: 0.01em;
  --ls-eyebrow: 0.1em;
  --ls-ui-eyebrow: 0.08em;
  --ls-ui-label: 0.05em;
  /* Uppercase group labels (layout spec: 10.5-11px, 0.07em). */
  --ls-ui-group: 0.07em;
  --ls-none: 0;

  /* Four-pixel spacing scale */
  --space-0: 0;
  --space-0-5: 2px;
  --space-1: 4px;
  --space-1-5: 6px;
  --space-2: 8px;
  --space-2-5: 10px;
  --space-3: 12px;
  --space-3-5: 14px;
  --space-4: 16px;
  --space-card: 18px;
  --space-5: 20px;
  --space-5-5: 22px;
  --space-6: 24px;
  --space-7: 28px;
  --space-8: 32px;
  --space-10: 40px;
  --space-12: 48px;
  --space-16: 64px;
  --space-20: 80px;
  --space-24: 96px;
  --space-32: 128px;
  --container-sm: 640px;
  --container-md: 960px;
  --container-lg: 1200px;
  --container-xl: 1400px;
  /*
   * Component tokens are implementation defaults, not required customer-theme
   * values. Consumers may override them for density/layout customization.
   */
  --component-data-table-min-width: 640px;
  /* Per-depth indent of a SpecraDataTable child row (tree rows). */
  --component-data-table-indent: 18px;
  --gutter-page: clamp(24px, 5vw, 96px);
  --section-y: clamp(64px, 9vw, 128px);
  --control-height-xs: 20px;
  --control-height-sm: 26px;
  --control-height-md: 32px;
  --control-height-lg: 38px;
  --control-height-tab: 34px;
  --space-ui-gap: 9px;
  --space-row-y: 3.5px;
  --space-status-y: 3px;
  --space-progress-gap: 3px;
  --space-kpi-gap: 7px;
  --avatar-sm: 24px;
  --avatar-md: 36px;
  --avatar-lg: 40px;
  --icon-tile-sm: 24px;
  --icon-tile-md: 26px;
  --icon-tile-lg: 36px;
  --icon-size-ui: 13px;
  --component-logo-lockup-width: 112px;
  --component-logo-ratio: 6.6474358974;
  --switch-width: 38px;
  --switch-height: 22px;
  --switch-thumb: 18px;
  --switch-travel: 16px;
  --component-sidebar-collapsed-width: 56px;
  --component-sidebar-width: 232px;
  --component-briefing-rail-width: 324px;
  --component-assist-panel-width: 336px;
  --component-topbar-height: 50px;
  --component-work-column-width: 860px;
  --component-audit-summary-width: 190px;
  --component-risk-matrix-width: 230px;
  --component-detail-aside-width: 320px;
  --component-gantt-min-width: 520px;
  --component-gantt-label-min-width: 120px;
  --component-gantt-label-max-width: 220px;
  --component-gantt-track-min-width: 280px;
  --component-command-results-max-height: 420px;
  --component-search-trigger-width: 200px;
  --component-master-list-min-height: 180px;
  --component-master-detail-min-height: 240px;
  --component-master-list-min-width: 280px;
  --component-overlay-list-max-height: 236px;
  --component-overlay-edge-gap: 24px;
  --component-spinner-duration: 1000ms;
  --component-spinner-reduced-duration: 3000ms;
  --component-shimmer-duration: 1500ms;
  --component-shimmer-reduced-duration: 6000ms;
  --component-command-top-mobile: 12%;
  --component-command-top-desktop: 18%;
  --component-sidebar-mobile-max-height: 45dvh;
  --component-workroom-mobile-max-height: 40dvh;
  --component-overlay-actions-max-width: 45%;
  --component-page-padding-x: 36px;
  --component-page-padding-top: 30px;
  --component-page-padding-bottom: 48px;
  --component-risk-cell-height: 40px;
  --component-calendar-day-height: 24px;
  --component-risk-axis-indent: 38px;
  --component-progress-compact-width: 150px;
  --component-progress-track-height: 4px;
  --component-progress-track-height-thin: 3px;
  --component-schedule-marker-bleed: -8px;
  --component-timeline-marker-column: 16px;
  --component-job-state-column: 12px;
  --component-job-percent-column: 44px;
  --component-job-target-column: 110px;
  --ls-key-hint: 0.04em;

  /* Shape, elevation, and motion */
  --radius-xs: 2px;
  --radius-badge: 3px;
  --radius-sm: 4px;
  --radius-control: 5px;
  --radius-md: 6px;
  --radius: var(--radius-md);
  --radius-lg: 8px;
  --radius-xl: 12px;
  --radius-rail: 20px;
  --radius-pill: 999px;
  --stroke-hair: 0.5px;
  --stroke-thin: 1px;
  --stroke-med: 1.5px;
  --stroke-bold: 3px;
  --shadow-xs: 0 1px 2px rgb(53 46 42 / 5%);
  --shadow-sm: 0 1px 2px rgb(53 46 42 / 4%), 0 2px 6px rgb(53 46 42 / 5%);
  --shadow-md:
    0 1px 2px rgb(53 46 42 / 4%), 0 4px 10px rgb(53 46 42 / 5%), 0 10px 24px rgb(53 46 42 / 6%);
  --shadow-lg:
    0 1px 2px rgb(53 46 42 / 4%), 0 8px 18px rgb(53 46 42 / 6%), 0 24px 48px rgb(53 46 42 / 8%);
  --shadow-focus: 0 0 0 3px rgb(50 101 156 / 28%);
  --ease-standard: cubic-bezier(0.32, 0.72, 0, 1);
  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);
  --dur-fast: 120ms;
  --dur-base: 200ms;
  --dur-slow: 320ms;
}

/*
 * Product semantic theme. It follows the monorepo-wide contract: light values
 * live on :root and the existing DarkModeProvider toggles \`.dark\` on <html>.
 */
:root {
  color-scheme: light;
  font-family: var(--font-text);
  --background: 60 10% 96.1%;
  --foreground: 0 0% 6.7%;
  --card: 0 0% 100%;
  --card-foreground: 0 0% 6.7%;
  --popover: 0 0% 100%;
  --popover-foreground: 0 0% 6.7%;
  --primary: 0 0% 9.8%;
  --primary-foreground: 0 0% 98%;
  --secondary: 43 20% 93.1%;
  --secondary-foreground: 0 0% 6.7%;
  --muted: 43 20% 93.1%;
  --muted-foreground: 30 4.3% 54.1%;
  --accent: 38 22.4% 90.4%;
  --accent-foreground: 0 0% 6.7%;
  --destructive: 0 56.2% 34.9%;
  --destructive-foreground: 0 0% 98%;
  --border: 36 23.8% 91.8%;
  --border-strong: 38.2 19.3% 88.8%;
  --input: 38.2 16.4% 86.9%;
  --ring: 211.1 85.5% 32.4%;
  --brand: 211.1 85.5% 32.4%;
  --brand-foreground: 0 0% 98%;
  --brand-muted: 212 48.4% 93.9%;
  --success: 113.2 41.7% 24.9%;
  --success-foreground: 0 0% 98%;
  --success-muted: 106.7 23.1% 92.4%;
  --warning: 40.1 100% 30.2%;
  --warning-foreground: 0 0% 98%;
  --warning-muted: 42.2 77.1% 93.1%;
  --danger: 0 56.2% 34.9%;
  --danger-foreground: 0 0% 98%;
  --danger-muted: 0 41.9% 93.9%;
  --info: 211.1 85.5% 32.4%;
  --info-foreground: 0 0% 98%;
  --info-muted: 212 48.4% 93.9%;
  /* Routed / escalated / corrected (D115 #3): the fifth status hue, on the same
     lightness and saturation steps as success, danger and info. */
  --violet: 262 45% 40%;
  --violet-foreground: 0 0% 98%;
  --violet-muted: 262 38% 93.9%;
  /* High severity (S4 follow-up, 2026-09-30): between warning (Moderate) and
     danger (Blocking/Critical), on the same lightness and saturation steps.
     Text on tint is 7.1:1 light, 6.1:1 dark. */
  --orange: 24 80% 28%;
  --orange-foreground: 0 0% 98%;
  --orange-muted: 26 70% 93.5%;
  --manila: 40 17% 91%;
  --manila-hover: 43 24% 94%;
  --manila-border: 39 19% 81%;

  /* Canonical aliases plus the exact Delivery surface hierarchy. */
  --surface-page: var(--ref-color-offwhite);
  --surface-card: var(--ref-color-white);
  --surface-paper: var(--ref-color-true-white);
  --surface-field: var(--ref-color-true-white);
  --surface-hover: #fbfaf7;
  --surface-sunken: var(--ref-color-gray-00);
  --surface-inverse: var(--ref-color-black);
  --surface-canvas: #ffffff;
  --surface-rail: #fbfaf8;
  --surface-panel: #faf9f6;
  --surface-chip: #f1efea;
  --surface-row-highlight: #fdf9f1;
  --surface-track: #edeae3;
  --surface-nav-hover: #ece8e1;
  /* Component semantics: customer themes override these without replacing
     brand palette primitives or component implementation details. */
  --avatar-background: var(--ref-color-wood);
  --avatar-foreground: var(--ref-color-sand);
  --switch-track-unchecked: var(--ref-color-gray-02);
  --switch-thumb-background: var(--ref-color-true-white);
  --tooltip-background: var(--ref-color-charcoal);
  --tooltip-foreground: var(--ref-color-white);
  --text-primary: #111111;
  --text-secondary: #6f6a64;
  --text-muted: #8f8a85;
  --text-faint: #a29d95;
  --text-ghost: #c9c4bc;
  --text-placeholder: #a29d95;
  --text-disabled: #a29d95;
  --text-on-dark: var(--ref-color-sand);
  --text-on-dark-strong: var(--ref-color-white);
  --text-link: var(--ref-color-blue);
  --border-default: #efebe5;
  --border-subtle: #f2efe9;
  --border-control: #e3dfd8;
  --border-card: #ebe7e0;
  --border-dashed: #d6d1c9;
  --border-focus: var(--ref-color-black);
  --accent-blue: var(--ref-color-blue);
  --accent-green: var(--ref-color-green);
  --accent-red: var(--ref-color-red);
  --accent-yellow: #9a6700;
  --status-success: var(--ref-color-green);
  --status-success-bg: #e9f0e7;
  --status-warning: #9a6700;
  --status-warning-bg: #fbf3e0;
  --status-error: var(--ref-color-red);
  --status-error-bg: #f6e9e9;
  --status-info: var(--ref-color-blue);
  --status-info-bg: #e8eff7;
  --cta-bg: var(--ref-color-charcoal);
  --cta-bg-hover: #000000;
  --cta-text: var(--ref-color-white);
  --scrim: rgb(17 17 17 / 32%);
}

.dark {
  color-scheme: dark;
  --background: 36 12.2% 8%;
  --foreground: 42.9 18.9% 92.7%;
  --card: 40 10.3% 11.4%;
  --card-foreground: 42.9 18.9% 92.7%;
  --popover: 40 10.3% 11.4%;
  --popover-foreground: 42.9 18.9% 92.7%;
  --primary: 42.9 18.9% 92.7%;
  --primary-foreground: 36 12.2% 8%;
  --secondary: 40 10.3% 17.1%;
  --secondary-foreground: 42.9 18.9% 92.7%;
  --muted: 40 10.3% 17.1%;
  --muted-foreground: 40 5.2% 54.5%;
  --accent: 30 5.9% 13.3%;
  --accent-foreground: 42.9 18.9% 92.7%;
  --destructive: 6.1 57.4% 69.6%;
  --destructive-foreground: 36 12.2% 8%;
  --border: 34.3 8.6% 15.9%;
  --border-strong: 30 5.9% 20%;
  --input: 37.5 7.1% 22%;
  --ring: 212.2 53.9% 70.2%;
  --brand: 212.2 53.9% 70.2%;
  --brand-foreground: 36 12.2% 8%;
  --brand-muted: 213.3 27.8% 19%;
  --success: 104.4 29.3% 63.9%;
  --success-foreground: 36 12.2% 8%;
  --success-muted: 98.8 21.5% 15.5%;
  --warning: 39.3 58.6% 61.2%;
  --warning-foreground: 36 12.2% 8%;
  --warning-muted: 40 33.3% 15.9%;
  --danger: 6.1 57.4% 69.6%;
  --danger-foreground: 36 12.2% 8%;
  --danger-muted: 5 26.1% 18%;
  --info: 212.2 53.9% 70.2%;
  --info-foreground: 36 12.2% 8%;
  --info-muted: 213.3 27.8% 19%;
  --violet: 262 50% 73%;
  --violet-foreground: 36 12.2% 8%;
  --violet-muted: 262 27% 19%;
  --orange: 24 62% 66%;
  --orange-foreground: 36 12.2% 8%;
  --orange-muted: 22 30% 17.5%;
  --manila: 36 8% 18%;
  --manila-hover: 36 8% 22%;
  --manila-border: 36 8% 28%;
  --surface-page: #171512;
  --surface-card: #201e1a;
  --surface-paper: #201e1a;
  --surface-field: #201e1a;
  --surface-hover: #262420;
  --surface-sunken: #302d27;
  --surface-inverse: #f0eee9;
  --surface-canvas: #201e1a;
  --surface-rail: #1b1917;
  --surface-panel: #282520;
  --surface-chip: #302d27;
  --surface-row-highlight: #2b2820;
  --surface-track: #33302a;
  --surface-nav-hover: #242220;
  --avatar-background: #3a3530;
  --avatar-foreground: #f0eee9;
  --switch-track-unchecked: #57544e;
  --switch-thumb-background: #ffffff;
  --tooltip-background: #f0eee9;
  --tooltip-foreground: #171512;
  --text-primary: #f0eee9;
  --text-secondary: #a9a59d;
  --text-muted: #918d85;
  --text-faint: #736f68;
  --text-ghost: #57544e;
  --text-placeholder: #736f68;
  --text-disabled: #736f68;
  --text-on-dark: #d9d6cf;
  --text-on-dark-strong: #f0eee9;
  --text-link: #8ab0dc;
  --border-default: #2c2925;
  --border-subtle: #282623;
  --border-control: #3c3934;
  --border-card: #33302b;
  --border-dashed: #474440;
  --border-focus: #f0eee9;
  --accent-blue: #8ab0dc;
  --accent-green: #96be88;
  --accent-red: #de8e85;
  --accent-yellow: #d6ae62;
  --status-success: #96be88;
  --status-success-bg: #25301f;
  --status-warning: #d6ae62;
  --status-warning-bg: #362d1b;
  --status-error: #de8e85;
  --status-error-bg: #3a2422;
  --status-info: #8ab0dc;
  --status-info-bg: #232f3e;
  --cta-bg: #f0eee9;
  --cta-bg-hover: #ffffff;
  --cta-text: #171512;
  --scrim: rgb(0 0 0 / 55%);
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui-components/src/styles/specra-tokens.css"],"names":[],"mappings":"AAAA;EACE;;;IAGE;EACF,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;EAC1B,iCAAiC;EACjC,gCAAgC;EAChC,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,wBAAwB;EACxB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,iCAAiC;EACjC,4BAA4B;;EAE5B,0EAA0E;EAC1E,gFAAgF;EAChF,0EAA0E;EAC1E,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,iEAAiE;EACjE,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,gFAAgF;EAChF,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B;EAC7B,yFAAyF;EACzF,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,aAAa;EACb,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;;EAEZ,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB;;;IAGE;EACF,uCAAuC;EACvC,iEAAiE;EACjE,mCAAmC;EACnC,qCAAqC;EACrC,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oCAAoC;EACpC,oCAAoC;EACpC,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,yCAAyC;EACzC,gCAAgC;EAChC,sCAAsC;EACtC,qCAAqC;EACrC,+BAA+B;EAC/B,oCAAoC;EACpC,sCAAsC;EACtC,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,6CAA6C;EAC7C,uCAAuC;EACvC,yCAAyC;EACzC,2CAA2C;EAC3C,wCAAwC;EACxC,0CAA0C;EAC1C,kCAAkC;EAClC,oCAAoC;EACpC,4CAA4C;EAC5C,oCAAoC;EACpC,4CAA4C;EAC5C,mCAAmC;EACnC,oCAAoC;EACpC,4CAA4C;EAC5C,6CAA6C;EAC7C,0CAA0C;EAC1C,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,kCAAkC;EAClC,qCAAqC;EACrC,kCAAkC;EAClC,yCAAyC;EACzC,sCAAsC;EACtC,2CAA2C;EAC3C,uCAAuC;EACvC,wCAAwC;EACxC,kCAAkC;EAClC,oCAAoC;EACpC,oCAAoC;EACpC,qBAAqB;;EAErB,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,uEAAuE;EACvE;+FAC6F;EAC7F;+FAC6F;EAC7F,+CAA+C;EAC/C,+CAA+C;EAC/C,yCAAyC;EACzC,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;EAGE;AACF;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;EACpB,+BAA+B;EAC/B,oBAAoB;EACpB,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,qBAAqB;EACrB,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,kCAAkC;EAClC,wBAAwB;EACxB,iCAAiC;EACjC,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,8BAA8B;EAC9B,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B;kEACgE;EAChE,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B;;+CAE6C;EAC7C,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;EAC5B,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;;EAE3B,iEAAiE;EACjE,yCAAyC;EACzC,sCAAsC;EACtC,4CAA4C;EAC5C,4CAA4C;EAC5C,wBAAwB;EACxB,0CAA0C;EAC1C,yCAAyC;EACzC,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;EAC5B;oEACkE;EAClE,0CAA0C;EAC1C,0CAA0C;EAC1C,kDAAkD;EAClD,sDAAsD;EACtD,+CAA+C;EAC/C,4CAA4C;EAC5C,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,qCAAqC;EACrC,6CAA6C;EAC7C,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sCAAsC;EACtC,oCAAoC;EACpC,sCAAsC;EACtC,kCAAkC;EAClC,wBAAwB;EACxB,wCAAwC;EACxC,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,0BAA0B;EAC1B,oCAAoC;EACpC,yBAAyB;EACzB,mCAAmC;EACnC,uBAAuB;EACvB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,mCAAmC;EACnC,yBAAyB;EACzB,sCAAsC;EACtC,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,wCAAwC;EACxC,uBAAuB;EACvB,iCAAiC;EACjC,uBAAuB;EACvB,qCAAqC;EACrC,8BAA8B;EAC9B,qCAAqC;EACrC,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,iCAAiC;EACjC,iCAAiC;EACjC,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,gCAAgC;EAChC,2BAA2B;EAC3B,oBAAoB;EACpB,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;EAC7B,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[":root {\n  /*\n   * Reference tokens are private implementation inputs. Components must never\n   * consume them directly; customer themes override semantic tokens below.\n   */\n  --ref-color-offwhite: #f6f6f4;\n  --ref-color-white: #fafafa;\n  --ref-color-true-white: #ffffff;\n  --ref-color-sand: #e8e4dd;\n  --ref-color-wood: #352e2a;\n  --ref-color-charcoal: #191919;\n  --ref-color-black: #111111;\n  --ref-color-gray-00: #f1f1f1;\n  --ref-color-gray-01: #d9d9d9;\n  --ref-color-gray-02: #c5c5c5;\n  --ref-color-gray-03: #b6b6b6;\n  --ref-color-gray-04: #838383;\n  --ref-color-gray-05: #525252;\n  --ref-color-green: #2b5a25;\n  --ref-color-green-medium: #b2cdbc;\n  --ref-color-green-light: #ddebe2;\n  --ref-color-blue: #0c5099;\n  --ref-color-blue-medium: #a6c3ea;\n  --ref-color-blue-light: #ddebff;\n  --ref-color-red: #8b2727;\n  --ref-color-red-medium: #8e4b4a;\n  --ref-color-red-light: #e1c9c9;\n  --ref-color-yellow: #ffc30e;\n  --ref-color-yellow-medium: #ffe8a0;\n  --ref-color-yellow-light: #fff4d3;\n  --ref-shadow-ink: 53, 46, 42;\n\n  /* System typography tokens. rem values honor the host's root font size. */\n  --font-display: \"Neue Haas Grotesk Display\", \"Helvetica Neue\", Arial, sans-serif;\n  --font-text: \"Neue Haas Grotesk Text\", \"Helvetica Neue\", Arial, sans-serif;\n  --fw-light: 300;\n  --fw-regular: 400;\n  --fw-medium: 500;\n  --fw-bold: 700;\n  --fs-display: 4rem;\n  --fs-h1: 3rem;\n  --fs-h2: 2.25rem;\n  --fs-h3: 1.75rem;\n  --fs-h4: 1.375rem;\n  --fs-body-lg: 1.25rem;\n  --fs-body: 1.125rem;\n  --fs-body-sm: 1rem;\n  --fs-caption: 0.875rem;\n  --fs-micro: 0.75rem;\n  /* Dense product scale used by the supplied Delivery prototype. */\n  --fs-ui-micro: 0.625rem;\n  --fs-ui-label: 0.65625rem;\n  --fs-ui-eyebrow: 0.6875rem;\n  --fs-ui-meta: 0.71875rem;\n  --fs-ui-caption: 0.75rem;\n  /* The layout spec's 12.5px body copy (D115): dense rows, facts, drawer prose. */\n  --fs-ui-body: 0.78125rem;\n  --fs-ui: 0.8125rem;\n  --fs-ui-emphasis: 0.84375rem;\n  --fs-ui-title: 0.9375rem;\n  --fs-ui-page-title: 1.1875rem;\n  --fs-ui-home-title: 1.6875rem;\n  /* The layout spec's big number, one per page (34px, the low end of its 34-48px range). */\n  --fs-ui-verdict: 2.125rem;\n  --fs-audit-score: 2.875rem;\n  --lh-display: 1;\n  --lh-h1: 1.06;\n  --lh-h2: 1.08;\n  --lh-tight: 1.2;\n  --lh-home: 1.15;\n  --lh-body: 1.6;\n  --lh-snug: 1.45;\n  --ls-display: -0.01em;\n  --ls-body: 0.01em;\n  --ls-eyebrow: 0.1em;\n  --ls-ui-eyebrow: 0.08em;\n  --ls-ui-label: 0.05em;\n  /* Uppercase group labels (layout spec: 10.5-11px, 0.07em). */\n  --ls-ui-group: 0.07em;\n  --ls-none: 0;\n\n  /* Four-pixel spacing scale */\n  --space-0: 0;\n  --space-0-5: 2px;\n  --space-1: 4px;\n  --space-1-5: 6px;\n  --space-2: 8px;\n  --space-2-5: 10px;\n  --space-3: 12px;\n  --space-3-5: 14px;\n  --space-4: 16px;\n  --space-card: 18px;\n  --space-5: 20px;\n  --space-5-5: 22px;\n  --space-6: 24px;\n  --space-7: 28px;\n  --space-8: 32px;\n  --space-10: 40px;\n  --space-12: 48px;\n  --space-16: 64px;\n  --space-20: 80px;\n  --space-24: 96px;\n  --space-32: 128px;\n  --container-sm: 640px;\n  --container-md: 960px;\n  --container-lg: 1200px;\n  --container-xl: 1400px;\n  /*\n   * Component tokens are implementation defaults, not required customer-theme\n   * values. Consumers may override them for density/layout customization.\n   */\n  --component-data-table-min-width: 640px;\n  /* Per-depth indent of a SpecraDataTable child row (tree rows). */\n  --component-data-table-indent: 18px;\n  --gutter-page: clamp(24px, 5vw, 96px);\n  --section-y: clamp(64px, 9vw, 128px);\n  --control-height-xs: 20px;\n  --control-height-sm: 26px;\n  --control-height-md: 32px;\n  --control-height-lg: 38px;\n  --control-height-tab: 34px;\n  --space-ui-gap: 9px;\n  --space-row-y: 3.5px;\n  --space-status-y: 3px;\n  --space-progress-gap: 3px;\n  --space-kpi-gap: 7px;\n  --avatar-sm: 24px;\n  --avatar-md: 36px;\n  --avatar-lg: 40px;\n  --icon-tile-sm: 24px;\n  --icon-tile-md: 26px;\n  --icon-tile-lg: 36px;\n  --icon-size-ui: 13px;\n  --component-logo-lockup-width: 112px;\n  --component-logo-ratio: 6.6474358974;\n  --switch-width: 38px;\n  --switch-height: 22px;\n  --switch-thumb: 18px;\n  --switch-travel: 16px;\n  --component-sidebar-collapsed-width: 56px;\n  --component-sidebar-width: 232px;\n  --component-briefing-rail-width: 324px;\n  --component-assist-panel-width: 336px;\n  --component-topbar-height: 50px;\n  --component-work-column-width: 860px;\n  --component-audit-summary-width: 190px;\n  --component-risk-matrix-width: 230px;\n  --component-detail-aside-width: 320px;\n  --component-gantt-min-width: 520px;\n  --component-gantt-label-min-width: 120px;\n  --component-gantt-label-max-width: 220px;\n  --component-gantt-track-min-width: 280px;\n  --component-command-results-max-height: 420px;\n  --component-search-trigger-width: 200px;\n  --component-master-list-min-height: 180px;\n  --component-master-detail-min-height: 240px;\n  --component-master-list-min-width: 280px;\n  --component-overlay-list-max-height: 236px;\n  --component-overlay-edge-gap: 24px;\n  --component-spinner-duration: 1000ms;\n  --component-spinner-reduced-duration: 3000ms;\n  --component-shimmer-duration: 1500ms;\n  --component-shimmer-reduced-duration: 6000ms;\n  --component-command-top-mobile: 12%;\n  --component-command-top-desktop: 18%;\n  --component-sidebar-mobile-max-height: 45dvh;\n  --component-workroom-mobile-max-height: 40dvh;\n  --component-overlay-actions-max-width: 45%;\n  --component-page-padding-x: 36px;\n  --component-page-padding-top: 30px;\n  --component-page-padding-bottom: 48px;\n  --component-risk-cell-height: 40px;\n  --component-calendar-day-height: 24px;\n  --component-risk-axis-indent: 38px;\n  --component-progress-compact-width: 150px;\n  --component-progress-track-height: 4px;\n  --component-progress-track-height-thin: 3px;\n  --component-schedule-marker-bleed: -8px;\n  --component-timeline-marker-column: 16px;\n  --component-job-state-column: 12px;\n  --component-job-percent-column: 44px;\n  --component-job-target-column: 110px;\n  --ls-key-hint: 0.04em;\n\n  /* Shape, elevation, and motion */\n  --radius-xs: 2px;\n  --radius-badge: 3px;\n  --radius-sm: 4px;\n  --radius-control: 5px;\n  --radius-md: 6px;\n  --radius: var(--radius-md);\n  --radius-lg: 8px;\n  --radius-xl: 12px;\n  --radius-rail: 20px;\n  --radius-pill: 999px;\n  --stroke-hair: 0.5px;\n  --stroke-thin: 1px;\n  --stroke-med: 1.5px;\n  --stroke-bold: 3px;\n  --shadow-xs: 0 1px 2px rgb(53 46 42 / 5%);\n  --shadow-sm: 0 1px 2px rgb(53 46 42 / 4%), 0 2px 6px rgb(53 46 42 / 5%);\n  --shadow-md:\n    0 1px 2px rgb(53 46 42 / 4%), 0 4px 10px rgb(53 46 42 / 5%), 0 10px 24px rgb(53 46 42 / 6%);\n  --shadow-lg:\n    0 1px 2px rgb(53 46 42 / 4%), 0 8px 18px rgb(53 46 42 / 6%), 0 24px 48px rgb(53 46 42 / 8%);\n  --shadow-focus: 0 0 0 3px rgb(50 101 156 / 28%);\n  --ease-standard: cubic-bezier(0.32, 0.72, 0, 1);\n  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);\n  --dur-fast: 120ms;\n  --dur-base: 200ms;\n  --dur-slow: 320ms;\n}\n\n/*\n * Product semantic theme. It follows the monorepo-wide contract: light values\n * live on :root and the existing DarkModeProvider toggles `.dark` on <html>.\n */\n:root {\n  color-scheme: light;\n  font-family: var(--font-text);\n  --background: 60 10% 96.1%;\n  --foreground: 0 0% 6.7%;\n  --card: 0 0% 100%;\n  --card-foreground: 0 0% 6.7%;\n  --popover: 0 0% 100%;\n  --popover-foreground: 0 0% 6.7%;\n  --primary: 0 0% 9.8%;\n  --primary-foreground: 0 0% 98%;\n  --secondary: 43 20% 93.1%;\n  --secondary-foreground: 0 0% 6.7%;\n  --muted: 43 20% 93.1%;\n  --muted-foreground: 30 4.3% 54.1%;\n  --accent: 38 22.4% 90.4%;\n  --accent-foreground: 0 0% 6.7%;\n  --destructive: 0 56.2% 34.9%;\n  --destructive-foreground: 0 0% 98%;\n  --border: 36 23.8% 91.8%;\n  --border-strong: 38.2 19.3% 88.8%;\n  --input: 38.2 16.4% 86.9%;\n  --ring: 211.1 85.5% 32.4%;\n  --brand: 211.1 85.5% 32.4%;\n  --brand-foreground: 0 0% 98%;\n  --brand-muted: 212 48.4% 93.9%;\n  --success: 113.2 41.7% 24.9%;\n  --success-foreground: 0 0% 98%;\n  --success-muted: 106.7 23.1% 92.4%;\n  --warning: 40.1 100% 30.2%;\n  --warning-foreground: 0 0% 98%;\n  --warning-muted: 42.2 77.1% 93.1%;\n  --danger: 0 56.2% 34.9%;\n  --danger-foreground: 0 0% 98%;\n  --danger-muted: 0 41.9% 93.9%;\n  --info: 211.1 85.5% 32.4%;\n  --info-foreground: 0 0% 98%;\n  --info-muted: 212 48.4% 93.9%;\n  /* Routed / escalated / corrected (D115 #3): the fifth status hue, on the same\n     lightness and saturation steps as success, danger and info. */\n  --violet: 262 45% 40%;\n  --violet-foreground: 0 0% 98%;\n  --violet-muted: 262 38% 93.9%;\n  /* High severity (S4 follow-up, 2026-09-30): between warning (Moderate) and\n     danger (Blocking/Critical), on the same lightness and saturation steps.\n     Text on tint is 7.1:1 light, 6.1:1 dark. */\n  --orange: 24 80% 28%;\n  --orange-foreground: 0 0% 98%;\n  --orange-muted: 26 70% 93.5%;\n  --manila: 40 17% 91%;\n  --manila-hover: 43 24% 94%;\n  --manila-border: 39 19% 81%;\n\n  /* Canonical aliases plus the exact Delivery surface hierarchy. */\n  --surface-page: var(--ref-color-offwhite);\n  --surface-card: var(--ref-color-white);\n  --surface-paper: var(--ref-color-true-white);\n  --surface-field: var(--ref-color-true-white);\n  --surface-hover: #fbfaf7;\n  --surface-sunken: var(--ref-color-gray-00);\n  --surface-inverse: var(--ref-color-black);\n  --surface-canvas: #ffffff;\n  --surface-rail: #fbfaf8;\n  --surface-panel: #faf9f6;\n  --surface-chip: #f1efea;\n  --surface-row-highlight: #fdf9f1;\n  --surface-track: #edeae3;\n  --surface-nav-hover: #ece8e1;\n  /* Component semantics: customer themes override these without replacing\n     brand palette primitives or component implementation details. */\n  --avatar-background: var(--ref-color-wood);\n  --avatar-foreground: var(--ref-color-sand);\n  --switch-track-unchecked: var(--ref-color-gray-02);\n  --switch-thumb-background: var(--ref-color-true-white);\n  --tooltip-background: var(--ref-color-charcoal);\n  --tooltip-foreground: var(--ref-color-white);\n  --text-primary: #111111;\n  --text-secondary: #6f6a64;\n  --text-muted: #8f8a85;\n  --text-faint: #a29d95;\n  --text-ghost: #c9c4bc;\n  --text-placeholder: #a29d95;\n  --text-disabled: #a29d95;\n  --text-on-dark: var(--ref-color-sand);\n  --text-on-dark-strong: var(--ref-color-white);\n  --text-link: var(--ref-color-blue);\n  --border-default: #efebe5;\n  --border-subtle: #f2efe9;\n  --border-control: #e3dfd8;\n  --border-card: #ebe7e0;\n  --border-dashed: #d6d1c9;\n  --border-focus: var(--ref-color-black);\n  --accent-blue: var(--ref-color-blue);\n  --accent-green: var(--ref-color-green);\n  --accent-red: var(--ref-color-red);\n  --accent-yellow: #9a6700;\n  --status-success: var(--ref-color-green);\n  --status-success-bg: #e9f0e7;\n  --status-warning: #9a6700;\n  --status-warning-bg: #fbf3e0;\n  --status-error: var(--ref-color-red);\n  --status-error-bg: #f6e9e9;\n  --status-info: var(--ref-color-blue);\n  --status-info-bg: #e8eff7;\n  --cta-bg: var(--ref-color-charcoal);\n  --cta-bg-hover: #000000;\n  --cta-text: var(--ref-color-white);\n  --scrim: rgb(17 17 17 / 32%);\n}\n\n.dark {\n  color-scheme: dark;\n  --background: 36 12.2% 8%;\n  --foreground: 42.9 18.9% 92.7%;\n  --card: 40 10.3% 11.4%;\n  --card-foreground: 42.9 18.9% 92.7%;\n  --popover: 40 10.3% 11.4%;\n  --popover-foreground: 42.9 18.9% 92.7%;\n  --primary: 42.9 18.9% 92.7%;\n  --primary-foreground: 36 12.2% 8%;\n  --secondary: 40 10.3% 17.1%;\n  --secondary-foreground: 42.9 18.9% 92.7%;\n  --muted: 40 10.3% 17.1%;\n  --muted-foreground: 40 5.2% 54.5%;\n  --accent: 30 5.9% 13.3%;\n  --accent-foreground: 42.9 18.9% 92.7%;\n  --destructive: 6.1 57.4% 69.6%;\n  --destructive-foreground: 36 12.2% 8%;\n  --border: 34.3 8.6% 15.9%;\n  --border-strong: 30 5.9% 20%;\n  --input: 37.5 7.1% 22%;\n  --ring: 212.2 53.9% 70.2%;\n  --brand: 212.2 53.9% 70.2%;\n  --brand-foreground: 36 12.2% 8%;\n  --brand-muted: 213.3 27.8% 19%;\n  --success: 104.4 29.3% 63.9%;\n  --success-foreground: 36 12.2% 8%;\n  --success-muted: 98.8 21.5% 15.5%;\n  --warning: 39.3 58.6% 61.2%;\n  --warning-foreground: 36 12.2% 8%;\n  --warning-muted: 40 33.3% 15.9%;\n  --danger: 6.1 57.4% 69.6%;\n  --danger-foreground: 36 12.2% 8%;\n  --danger-muted: 5 26.1% 18%;\n  --info: 212.2 53.9% 70.2%;\n  --info-foreground: 36 12.2% 8%;\n  --info-muted: 213.3 27.8% 19%;\n  --violet: 262 50% 73%;\n  --violet-foreground: 36 12.2% 8%;\n  --violet-muted: 262 27% 19%;\n  --orange: 24 62% 66%;\n  --orange-foreground: 36 12.2% 8%;\n  --orange-muted: 22 30% 17.5%;\n  --manila: 36 8% 18%;\n  --manila-hover: 36 8% 22%;\n  --manila-border: 36 8% 28%;\n  --surface-page: #171512;\n  --surface-card: #201e1a;\n  --surface-paper: #201e1a;\n  --surface-field: #201e1a;\n  --surface-hover: #262420;\n  --surface-sunken: #302d27;\n  --surface-inverse: #f0eee9;\n  --surface-canvas: #201e1a;\n  --surface-rail: #1b1917;\n  --surface-panel: #282520;\n  --surface-chip: #302d27;\n  --surface-row-highlight: #2b2820;\n  --surface-track: #33302a;\n  --surface-nav-hover: #242220;\n  --avatar-background: #3a3530;\n  --avatar-foreground: #f0eee9;\n  --switch-track-unchecked: #57544e;\n  --switch-thumb-background: #ffffff;\n  --tooltip-background: #f0eee9;\n  --tooltip-foreground: #171512;\n  --text-primary: #f0eee9;\n  --text-secondary: #a9a59d;\n  --text-muted: #918d85;\n  --text-faint: #736f68;\n  --text-ghost: #57544e;\n  --text-placeholder: #736f68;\n  --text-disabled: #736f68;\n  --text-on-dark: #d9d6cf;\n  --text-on-dark-strong: #f0eee9;\n  --text-link: #8ab0dc;\n  --border-default: #2c2925;\n  --border-subtle: #282623;\n  --border-control: #3c3934;\n  --border-card: #33302b;\n  --border-dashed: #474440;\n  --border-focus: #f0eee9;\n  --accent-blue: #8ab0dc;\n  --accent-green: #96be88;\n  --accent-red: #de8e85;\n  --accent-yellow: #d6ae62;\n  --status-success: #96be88;\n  --status-success-bg: #25301f;\n  --status-warning: #d6ae62;\n  --status-warning-bg: #362d1b;\n  --status-error: #de8e85;\n  --status-error-bg: #3a2422;\n  --status-info: #8ab0dc;\n  --status-info-bg: #232f3e;\n  --cta-bg: #f0eee9;\n  --cta-bg-hover: #ffffff;\n  --cta-text: #171512;\n  --scrim: rgb(0 0 0 / 55%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
